import { render, staticRenderFns } from "./mobile-search.vue?vue&type=template&id=564e4ac2&scoped=true&"
import script from "./mobile-search.vue?vue&type=script&lang=js&"
export * from "./mobile-search.vue?vue&type=script&lang=js&"
import style0 from "./mobile-search.vue?vue&type=style&index=0&id=564e4ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e4ac2",
  null
  
)

export default component.exports